import React from "react";
import ReactSkeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Skeleton = (props) => <ReactSkeleton {...props} />;

export default Skeleton;
